import React from "react";
import { Link } from "react-router-dom";
const ProjectItem = ({ name_web, tags, img, key, id }) => {
	return (
		<div className="item_space" key={key}>
			<div className="pitem_container">
				<img src={img} alt={`image web: ${name_web}`} />
				<h3>{name_web}</h3>

				<div className="tags">
					{tags.slice(0, 3).map((tag, index) => (
						<a href={tag.link} target="_blank">
							<div className={`tag  ${tag}`} key={index}>
								{tag.name} <img src={tag.url} alt={`tag: ${tag.name}`} />
							</div>
						</a>
					))}
				</div>

				<Link to={`${id}`} className="link">
					<button className="button-red">Details</button>
				</Link>
			</div>
		</div>
	);
};

export default ProjectItem;
